import { render, staticRenderFns } from "./v-navbar.vue?vue&type=template&id=1c0cbbd6&scoped=true&"
import script from "./v-navbar.vue?vue&type=script&lang=js&"
export * from "./v-navbar.vue?vue&type=script&lang=js&"
import style0 from "./v-navbar.vue?vue&type=style&index=0&id=1c0cbbd6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c0cbbd6",
  null
  
)

export default component.exports